import { query } from '../../utils/query';

export const deleteSingleBlogRequest = (BlogId) => {
  return query({
    uri: `api/v1/admin/blog/${BlogId}/`,
    method: 'DELETE'
  });
};
